import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";
import styles from "./MarketingModal.module.css";
import PopUpModal from "../PopUpModal/PopUpModal";


export default function MarketingModal() {
    const dispatch = useDispatch();
    const marketingModalStatus = useSelector((state) => state.ui.marketingModalActive);

    const handleClose = () => {
        dispatch(uiActions.setMarketingModalStatus(false));
        sessionStorage.setItem('marketingPopupClosed', 'true');
    };

    return (
        <>
            {marketingModalStatus &&
                <PopUpModal handleClose={handleClose}>
                    <div className={styles.container}>
                    <h1>LIMITED TIME ONLY!</h1>
                    <p>Select any package for no additional cost!<br/><br/>Choose your favorite package and get more information about how we can help start the process.<br/><br/>This deal ends September 30th, 2024.</p>
                    <button type="button" onClick={handleClose}>Get Started</button>
                    </div>
                </PopUpModal>
            }
        </>
    );
}


export {MarketingModal} 

